<template>
	<aside class="absolute z-40 start-0 bottom-8">
		<button
			class="btn btn-primary-light rounded-s-none rounded-e-3xl shadow flex items-center justify-center p-4"
			@click.prevent="triggerScroll()"
		>
			<span class="text-xs pe-2" v-if="unreadCountLabel.length">{{
				unreadCountLabel
			}}</span>
			<ChevronDown class="size-2"></ChevronDown>
		</button>
	</aside>
</template>

<script setup lang="ts">
import ChevronDown from '@/assets/icons/chevron-down.svg'
import { computed } from 'vue'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()

const unreadCountLabel = computed<string>(() => {
	const unreadCount = chatStore.unreadMessagesCount

	if (unreadCount === 0) {
		return ''
	}

	if (unreadCount > 99) {
		return '99+'
	}

	return unreadCount.toString()
})

const triggerScroll = () => {
	const lastSeenMessage = chatStore.currentChannel?.lastSeenMessageIndex

	if (chatStore.unreadMessagesCount > 0) {
		const firstUnseenMessage = Number(lastSeenMessage) + 1

		if (chatStore.getLastVisibleMessage(false) === firstUnseenMessage) {
			// message is overflowing viewport
			// scroll by portion of the viewport to move on
			const scrollContainer = document.querySelector<HTMLElement>(
				'[data-messenger-scrollwrap]'
			)

			scrollContainer?.scrollBy({
				top: scrollContainer.clientHeight * 0.6,
				behavior: 'smooth'
			})
		} else {
			// scroll to next unseen message
			chatStore.handleScroll(false, true, undefined, firstUnseenMessage)
		}

		return
	}

	// scroll all the way down
	chatStore.handleScroll(false, true)
}
</script>

<style scoped lang="postcss"></style>
